import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseSearchForm } from '@shared/ui/base-search-form';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { UiColumn } from '@shared/ui/ui-column';
import { TextAreaControl } from '@shared/ui/controls/textarea-control.model';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { ToggleControl } from '../../../shared/ui/controls/toggle-control.model';
import { TextControl } from '../../../shared/ui/controls/text-control.model';
import { ItemSearchResult } from '@shared/interfaces/gridrows/item-search-result.interface';
import { SearchGridComponent } from '../../../shared/components/grid/search-grid.component';
import { ToolBarComponent } from '@progress/kendo-angular-toolbar';
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { CollectionSelect } from '../../../shared/ui/select-controls/collection-select.model';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { SecurityRole } from '../../../shared/literals/shared.literal';
import { OrganizationSelect } from '../../../shared/ui/select-controls/organizations-select.model';
import { CollectionSearchResult } from '../../../shared/interfaces/gridrows/collection-search-result.interface';
import { VisibleProperty } from '../../../shared/ui/control-options/control-option.interface';

@Component({
    selector: 'app-collection-list',
    templateUrl: './collection-list.component.html',
    styleUrls: ['./collection-list.component.css'],
    standalone: false
})
export class CollectionListComponent extends BaseSearchForm<CollectionSearchResult> implements OnInit {

  @ViewChild('toolbar') bar: ToolBarComponent;

  organizationId: Number | null;

  @Input() items: ToolbarItem[];

  ngOnInit(): void {

    var session = this.auth.getSession();

    this.organizationId = Number(session?.organizationId);

    var toolbarAddNew: ToolbarItem = {
      text: 'Add Collection',
      icon: faPlus,
      hasMultiple: false,
      cssClass: 'success',
      action: () => { this.redirectToNewCollection(); }
    };


    this.toolbarItems.unshift(toolbarAddNew);
  }
  constructor(private router: Router, private auth: AuthenticationService) {
    super();
    this.name = "Collection";
    this.apiController = "Collection";
    this.keyFieldName = "id";
    this.canFilterSearch = this.auth.isAdmin();

    this.initializeUiControls();
    this.setGridSettings();
  }
  override initializeUiControls() {

    const view = new ViewControl("");

    const search = new UiGroupControl("", "Search");

    const isActive = new ToggleControl("isActive", "Is Active?", true);

    var row = new ViewRowControl();
    row.controls.push(isActive);

    search.rows.push(row);
    view.controls.push(search);

    this.views.push(view);
  }

  setGridSettings(): void {
    this.gridSettings = {
      gridName: "CollectionSearch_Grid",
      showSubGrid: false,
      preloadData: true,
      columns: this.getColumns()
    };
  }

  private getColumns(): UiColumn[] {
    let cols: UiColumn[] = [];

    var name = new UiColumn("name", "Collection", 100);
    var isActive = new UiColumn("isActive", "Is Active?", 100, true, "boolean");

    cols.push(name, isActive);

    return cols;
  }

  public redirectToNewCollection() {
    this.router.navigate(['/Collection/Detail/0']);
  }
}
